import { render, staticRenderFns } from "./riderfenxi.vue?vue&type=template&id=5b666ab6&"
import script from "./riderfenxi.vue?vue&type=script&lang=js&"
export * from "./riderfenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports